// MBQ OCT 2025 RESTYLING
import React from 'react'
import { AuthConsumer } from 'react-check-auth'
import { Route, useLocation } from 'react-router-dom'
import { useFeature } from '../contexts/Feature/FeatureContext'
import _ from 'lodash'
import LinkToNewApp from '../components/Links/LinkToNewApp'
import UX_TYPE from '../globals/uxType'
import ROLES, { blinkCptRoles } from '../globals/userRoles'

const CustomRoute = ({ component: Component, page = true, routeProfile, portal, ...rest }) => {
  const mainUxOldApp = _.get(useFeature(), 'mainUxOldApp')
  const location = useLocation()

  return (
    <AuthConsumer>
      {({ userInfo }) => (
        userInfo ?
          (
            userInfo.uxPreference === UX_TYPE.OLD_APP ?
              (
                <Route {...rest} render={props => <Component {...props} />} />
              )
              :
              (
                page ?
                  <LinkToNewApp />
                  :
                  /^\/($|(administration|admin|edit)($|\/.*))/.test(location.pathname) ?
                    [ROLES.INVOICE, ROLES.CUSTOMER_SUPPORT, ROLES.INTERNAL_SUPPORT].includes(userInfo.role) ?
                      <Route {...rest} render={props => <Component {...props} />} />
                      :
                      null
                    :
                    /^\/($|(blinkcpt-help|oauth2-signin|oauth2-authorize|oauth2-error)($|\/.*))/.test(location.pathname) ?
                      blinkCptRoles.includes(userInfo.role) ?
                        <Route {...rest} render={props => <Component {...props} />} />
                        :
                        null
                    : null
              )
          )
          :
          (
            mainUxOldApp ?
            (
              <Route {...rest} render={props => <Component {...props} />} />
            )
            :
            (
              (/^\/student\/([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12})($|\/.*)/.test(location.pathname)) ?
                <Route {...rest} render={props => <Component {...props} />} />
                :
                /^\/($|(blinkcpt-help|oauth2-signin|oauth2-authorize|oauth2-error)($|\/.*))/.test(location.pathname) ?
                  <Route {...rest} render={props => <Component {...props} />} />
                  :
                  page && <LinkToNewApp />
            )
          )
      )}
    </AuthConsumer>
  )
}  

export default CustomRoute